import { useContextValue } from './molecule/WithContext';
import { IBotData } from '../models';
import { BotContextShape } from '../models/bot';

export const useBotContext = () => useContextValue() as BotContextShape;

export const useBotData = () => useContextValue(true) as IBotData;

